<!-- HERO BANNER START -->
<section class="hero-banner" id="index">
    <div class="container-fluid first_container_fluid">
      <div class="row row-gap-4 align-items-center mb-12">
        <div class="col-lg-3 d-lg-block d-none fade-in" data-wow-delay="920ms" style="z-index: 1;">
          <img class="" src="../../assets/index/img/user-block-1.webp" alt="Processus commercial" loading="lazy" width="445" height="486">
        </div>
        <div class="col-lg-6 fade-in" data-wow-delay="920ms">
          <div class="text-center">
            <h1 class="mb-24 lcp-text">Maîtrisez l'activité de votre équipe<br> commerciale sur terrain</h1>
            <h2 class="mb-48" style="font-size: clamp(30px, 1.823vw, 57px) !important;">
              L'outil de gestion qui simplifie votre quotidien
            </h2>
            <a class="cus-btn cus-btn-blue" href="../contact" routerLink="../contact" (click)="scrollToTop()">
              <div class="">
                <p class="button-text">Demander une Démo</p>
              </div>
              <div class="cus-btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4.01287 1.38251L4.08491 2.55217L13.1794 1.99206L0.514628 14.6568L1.34327 15.4855L14.008 2.8207L13.4479 11.9152L14.6176 11.9872L15.2855 1.14339L14.8567 0.714656L4.01287 1.38251Z"
                    fill="#008080" />
                </svg></div>
            </a>
            <a class="cus-btn" href="../contact" routerLink="../contact" (click)="scrollToTop()">
              <div class="">
                <p class="button-text">Essayer gratuitement</p>
              </div>
              <div class="cus-btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4.01287 1.38251L4.08491 2.55217L13.1794 1.99206L0.514628 14.6568L1.34327 15.4855L14.008 2.8207L13.4479 11.9152L14.6176 11.9872L15.2855 1.14339L14.8567 0.714656L4.01287 1.38251Z"
                    fill="#008080" />
                </svg></div>
            </a>
          </div>
        </div>
        <div class="col-lg-3 fade-in network_images" data-wow-delay="920ms">
            <img class=" d-block img-sec1 m-auto" src="../../assets/index/img/user-block-2.webp" width="445" height="486"
                alt="contact entre les membres de l'équipe" loading="lazy" fetchpriority="high">
            <img class=" d-block img-sec1 m-auto" src="../../assets/index/img/user-block-1.webp" width="445" height="486"
                alt="contact entre les membres de l'équipe" loading="lazy" fetchpriority="high" *ngIf="mobile">
            <!-- <img class="d-lg-none d-block mobile-img" src="../../assets/index/img/user-block-mobile.webp" width="400" height="437"
                alt="contact entre les membres de l'équipe" loading="lazy" fetchpriority="high"> -->
        </div>
      </div>
      <ul class="hash-tags-wrapper fade-in" data-wow-delay="920ms">
        <li class="hash-tags hash-tags-1">
          <p class="subtitle black">
            <span title="Solution de gestion commerciale innovante">#Gestion Commerciale 2025</span>
          </p>
        </li>
        <li class="hash-tags hash-tags-2">
          <p class="subtitle black"><span title="Free démo de la solution">#Offre Maroc</span></p>
        </li>
        <li class="hash-tags hash-tags-3">
          <p class="subtitle black">
            <span title="Découvrez notre programme de gestion commerciale 
            optimisé pour les entreprises marocaines">#Programme Gestion</span> </p>
        </li>
        <li class="hash-tags hash-tags-4">
          <p class="subtitle black">
            <span title="Gérez et maximisez votre couverture de contacts avec notre 
            solution innovante">#Contacts couverture</span></p>
        </li>
        <li class="hash-tags hash-tags-5">
          <p class="subtitle black">
            <span title="Une solution web complète pour simplifier et optimiser 
            votre gestion commerciale">#Solution Commerciale Web</span></p>
        </li>
        <li class="hash-tags hash-tags-6">
          <p class="subtitle black">
            <span title="Planifiez et suivez vos visites clients efficacement 
            avec notre outil dédié">#Visites Client</span></p>
        </li>
      </ul>
    </div>
  </section>
  <!-- HERO BANNER END -->
  <!-- about Us Start -->
  <section class="about-sec wow fadeInUp" data-wow-delay="400ms">
    <div class="container-fluid">
      <div class="row row-gap-4 align-items-center container-section">
        <div class="col-lg-6">
          <h4 class="black mb-16">Révolutionnez votre gestion commerciale dès maintenant !</h4>
          <p class="mb-24">Masterfield est conçu pour résoudre les défis quotidiens des commerciaux sur le terrain.
            Grâce à sa version mobile, il vous accompagne partout, vous permettant de travailler plus efficacement et de vous concentrer
            sur ce qui compte vraiment.</p>
            <h5 style="color:#008080" *ngIf="!mobile && !medium">Découvrez pourquoi il faut choisir <b>Masterfield ➜</b></h5>
            <h5 style="color:#008080" *ngIf="mobile || medium">Découvrez pourquoi il faut choisir <b>Masterfield ↓</b></h5>
        </div>
        <div class="col-lg-6">
          <div class="container-about">
            <img class="br-24 img-section2" src="../../assets/index/img/about/mf-section-about.webp" 
              alt="Dashboard interface de la solution master field" loading="lazy" width="940" height="488">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- about Us End -->

  <!-- Why Choose Us Start -->
  <section class="why-choose-sec py-80 wow fadeInUp" data-wow-delay="400ms" id="why-choose-sec">
    <div class="container-fluid">
      <div class="mb-24">
        <h3 class="fw-400">Pourquoi choisir Masterfield ?</h3>
      </div>
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 mt-3">
          <div class="why-choose-block-1">
            <div class="why-choose-icon mb-24">
              <img src="../../../assets/index/img/why_masterfield/gears_1.webp" width="48" height="48" alt="">
            </div>
            <p class="h4 black hover-content mb-24">Gestion complète des déplacements</p>
            <p class="mb-16">La solution va bien au-delà de
              la gestion des visites. De la planification à l'évaluation des KPI, notre
              plateforme offre une vue panoramique de votre performance commerciale.</p>
            <div class="circle_vector-1 circle_vector-5" *ngIf="mobile"></div>
            <div class="circle_vector-2 circle_vector-4" *ngIf="mobile"></div>
            <div class="circle_vector-1"></div>
            <div class="circle_vector-2"></div>
          </div>
        </div>
        <div class="col-lg-4 mt-3">
          <div class="why-choose-block-1">
            <div class="why-choose-icon mb-24">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <g clip-path="url(#clip0_11543_1978)">
                  <path
                    d="M7.76972 29.1677C8.09006 29.3821 8.45231 29.4846 8.81072 29.4846C9.41541 29.4846 10.0091 29.1924 10.3707 28.6522C13.4004 24.1248 18.4651 21.4219 23.9186 21.4219C29.356 21.4219 34.4123 24.1124 37.4442 28.6191C38.0224 29.4783 39.1874 29.7062 40.0465 29.1281C40.9058 28.5501 41.1337 27.3849 40.5556 26.5258C38.1332 22.9252 34.6601 20.2685 30.6913 18.8472C33.0714 16.9029 34.5938 13.9463 34.5938 10.6406C34.5938 4.79916 29.8415 0.046875 24 0.046875C18.1585 0.046875 13.4063 4.79916 13.4063 10.6406C13.4063 13.9226 14.9064 16.8607 17.2571 18.8054C13.2263 20.2214 9.70097 22.9103 7.25419 26.5666C6.67828 27.4272 6.90909 28.5918 7.76972 29.1677ZM24 3.79688C27.7736 3.79688 30.8438 6.867 30.8438 10.6406C30.8438 14.4142 27.7736 17.4844 24 17.4844C20.2264 17.4844 17.1563 14.4142 17.1563 10.6406C17.1563 6.867 20.2264 3.79688 24 3.79688ZM31.4773 33.2466L28.6821 35.263C28.2662 35.563 28.0921 36.0949 28.251 36.5803L29.3767 39.843C29.4242 39.9883 29.4425 40.1302 29.4364 40.2656C29.3965 41.1419 28.2983 41.7413 27.4928 41.1603L24.6976 39.1432C24.4897 38.9933 24.2449 38.9183 24.0001 38.9183C23.7553 38.9183 23.5105 38.9933 23.3026 39.1432L20.5074 41.1603C19.7019 41.7413 18.5984 41.1419 18.5635 40.2656C18.5582 40.1302 18.5769 39.9882 18.6245 39.843L19.7491 36.5803C19.908 36.0949 19.7339 35.563 19.318 35.263L16.5228 33.2466C15.5928 32.5757 16.0707 30.9844 17.2203 30.9844H20.6753C21.1895 30.9844 21.6451 30.7865 21.8039 30.301L22.8715 27.0173C23.0492 26.4745 23.5246 26.2031 24.0001 26.2031C24.4756 26.2031 24.951 26.4745 25.1287 27.0173L26.1963 30.301C26.3552 30.7865 26.8107 30.9844 27.3248 30.9844H30.7799C31.9294 30.9844 32.4073 32.5757 31.4773 33.2466ZM47.5086 39.8091L44.7133 41.8255C44.2974 42.1255 44.1233 42.6574 44.2823 43.1428L45.4079 46.4055C45.4554 46.5508 45.4737 46.6927 45.4676 46.8281C45.4278 47.7044 44.3295 48.3038 43.524 47.7228L40.7288 45.7057C40.5209 45.5558 40.2761 45.4808 40.0313 45.4808C39.7866 45.4808 39.5418 45.5558 39.3338 45.7057L36.5387 47.7228C35.7332 48.3038 34.6297 47.7044 34.5948 46.8281C34.5894 46.6927 34.6082 46.5507 34.6557 46.4055L35.7803 43.1428C35.9393 42.6574 35.7652 42.1255 35.3493 41.8255L32.554 39.8091C31.624 39.1382 32.102 37.5469 33.2515 37.5469H36.7066C37.2207 37.5469 37.6763 37.349 37.8352 36.8635L38.9028 33.5798C39.0804 33.037 39.5558 32.7656 40.0313 32.7656C40.5068 32.7656 40.9823 33.037 41.1599 33.5798L42.2275 36.8635C42.3864 37.349 42.842 37.5469 43.3561 37.5469H46.8112C47.9606 37.5469 48.4386 39.1382 47.5086 39.8091ZM15.4461 39.8091L12.6508 41.8255C12.2349 42.1255 12.0608 42.6574 12.2198 43.1428L13.3454 46.4055C13.3929 46.5508 13.4112 46.6927 13.4051 46.8281C13.3653 47.7044 12.267 48.3038 11.4615 47.7228L8.66625 45.7057C8.45831 45.5558 8.21353 45.4808 7.96875 45.4808C7.72397 45.4808 7.47919 45.5558 7.27125 45.7057L4.47609 47.7228C3.67059 48.3038 2.56706 47.7044 2.53219 46.8281C2.52684 46.6927 2.54559 46.5507 2.59313 46.4055L3.71775 43.1428C3.87666 42.6574 3.70256 42.1255 3.28669 41.8255L0.491437 39.8091C-0.438563 39.1382 0.0393749 37.5469 1.18894 37.5469H4.644C5.15813 37.5469 5.61375 37.349 5.77256 36.8635L6.84019 33.5798C7.01784 33.037 7.49325 32.7656 7.96875 32.7656C8.44425 32.7656 8.91966 33.037 9.09731 33.5798L10.1649 36.8635C10.3238 37.349 10.7794 37.5469 11.2935 37.5469H14.7486C15.8981 37.5469 16.3761 39.1382 15.4461 39.8091Z"
                    fill="#FAFAFA" />
                </g>
                <defs>
                  <clipPath id="clip0_11543_1978">
                    <rect width="48" height="48" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="h4 black hover-content mb-24">Expérience conviviale et intuitive</p>
            <p class="mb-16">La navigation dans notre interface intuitive devient un
              jeu d'enfant, laissant à vos équipes le temps de se concentrer sur l'essentiel :
              le lien avec vos clients.</p>
            <div class="circle_vector-1 circle_vector-5" *ngIf="mobile"></div>
            <div class="circle_vector-2 circle_vector-4" *ngIf="mobile"></div>
            <div class="circle_vector-1 circle_vector-3"></div>
            <div class="circle_vector-2 circle_vector-4"></div>
          </div>
        </div>
        <div class="col-lg-4 mt-3">
          <div class="why-choose-block-1">
            <div class="why-choose-icon mb-24">
              <img src="../../../assets/index/img/why_masterfield/customer_1.webp" width="48" height="48" alt="">
            </div>
            <p class="h4 black hover-content mb-24">Accompagnement et assistance</p>
            <p class="mb-16" style="font-size: 14px;">
              Nous offrons un accompagnement et une assistance personnalisée à
              chaque étape de votre projet. Notre équipe d'experts est disponible pour vous aider à
              intégrer nos solutions, répondre à vos questions et résoudre rapidement tout problème.</p>
            <div class="circle_vector-1 circle_vector-5" *ngIf="mobile"></div>
            <div class="circle_vector-2 circle_vector-4" *ngIf="mobile"></div>
            <div class="circle_vector-1 circle_vector-3"></div>
            <div class="circle_vector-2 circle_vector-4"></div>
          </div>
        </div>
      </div>
      <div class="row row-gap-4 justify-content-center">
        <div class="col-lg-4 mt-3">
          <div class="why-choose-block-1">
            <div class="why-choose-icon mb-24">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path
                  d="M35.0027 14.1604C28.2284 18.3131 23.3458 23.5578 21.3633 25.8885L16.2731 21.9009C16.1383 21.804 13.3441 24.2847 13.4183 24.3619L22.6885 33.7866C22.7566 33.8638 22.8505 33.8986 22.952 33.8986C22.9702 33.8986 22.9989 33.8986 23.0232 33.8926C23.1443 33.8653 23.2473 33.7835 23.2927 33.6624C24.786 29.8444 29.7172 21.8509 36.0144 16.0535C36.1265 15.9475 36.1658 15.7809 36.1038 15.637C36.1038 15.637 35.0966 14.1028 35.0027 14.1604Z"
                  fill="#FAFAFA" />
                <path
                  d="M41.0818 5.81864C27.0456 5.81864 24.6709 0.490692 24.6497 0.440714C24.5467 0.180223 24.2923 0.00605793 24.0045 0C24.0045 0 23.9985 0 23.9924 0C23.7137 0 23.4563 0.174165 23.3442 0.428598C23.3275 0.484634 20.9013 5.81864 6.91814 5.81864C6.5274 5.81864 6.21844 6.13517 6.21844 6.51682V30.3911C6.21844 40.1641 23.005 47.6305 23.7153 47.944C23.8092 47.9849 23.8985 48 24 48C24.0924 48 24.1923 47.9849 24.2817 47.944C24.998 47.6305 41.7815 40.1641 41.7815 30.3911V6.51682C41.7785 6.13517 41.468 5.81864 41.0818 5.81864ZM37.9196 29.0023C37.9196 36.649 24.7769 42.4994 24.2181 42.7417C24.1499 42.7766 24.0696 42.7887 23.9985 42.7887C23.9212 42.7887 23.85 42.7766 23.7774 42.7417C23.2246 42.4994 10.0773 36.649 10.0773 29.0023V10.3151C10.0773 10.0138 10.3212 9.76538 10.6256 9.76538C21.5738 9.76538 23.4714 5.59147 23.4896 5.55058C23.5759 5.34915 23.7758 5.21285 23.9954 5.21285C23.9985 5.21285 24.0045 5.21285 24.0045 5.21285C24.2287 5.21588 24.4271 5.35218 24.5073 5.55966C24.5255 5.59753 26.3853 9.76538 37.3713 9.76538C37.6758 9.76538 37.9181 10.0138 37.9181 10.3151L37.9196 29.0023Z"
                  fill="#FAFAFA" />
              </svg>
            </div>
            <p class="h4 black hover-content mb-24">Données sécurisées et intégrationn facile</p>
            <p class="mb-16">Vos données sont protégées par des mesures de sécurité avancées sur des serveurs
              garantissant confidentialité et conformité. Notre solution permet une intégration facile 
              à vos systèmes pour centraliser vos données.</p>
            <div class="circle_vector-1 circle_vector-5" *ngIf="mobile"></div>
            <div class="circle_vector-2 circle_vector-4" *ngIf="mobile"></div>
            <div class="circle_vector-1"></div>
            <div class="circle_vector-2"></div>
          </div>
        </div>
        <div class="col-lg-4 mt-3">
          <div class="why-choose-block-1">
            <div class="why-choose-icon mb-24">
              <img src="../../../assets/index/img/why_masterfield/continuous-improvement.webp" width="48" height="48" alt="">
            </div>
            <p class="h4 black hover-content mb-24">Ajustement aux besoins et amélioration continue</p>
            <p class="mb-16" style="font-size: 14px;">Nous nous ajustons à vos besoins spécifiques pour faciliter la mise en place de
              processus commerciaux sur mesure, garantissant une performance optimale et une satisfaction client
              maximale grâce à notre engagement continu dans l'amélioration.</p>
            <div class="circle_vector-1 circle_vector-5" *ngIf="mobile"></div>
            <div class="circle_vector-2 circle_vector-4" *ngIf="mobile"></div>
            <div class="circle_vector-1 circle_vector-5"></div>
            <div class="circle_vector-2 circle_vector-6"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Why Choose Us END -->
   
  <!-- Our Advantages Start -->
  <section class="testimonial-sec py-80 wow fadeInUp" data-wow-delay="800ms" id="advantages">
    <div class="container-fluid" >
      <div class="mb-24">
        <h3 class="fw-400">Nos avantages</h3>
      </div>
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-6">
          <div class="testimonial-img">
            <img src="../../assets/index/img/advantages/advantages.webp" alt="Image montrant les avantages de notre solution de gestion commerciale 
              pour les visites et actions, offrant une meilleure organisation, un suivi détaillé des interactions avec les clients, une gestion 
              optimale des ventes, et une planification efficace des déplacements. Notre outil permet d'améliorer la productivité des équipes 
              commerciales, de centraliser les données clients et de suivre les actions en temps réel pour une performance accrue et une satisfaction client maximale.">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="testimonial-wrapper">
            <div class="vertors-block" *ngIf="!mobile">
              <div class="vertors-block-1">
                <img src="../../assets/index/img/advantages/circle-1.webp" alt="">
              </div>
              <div class="vertors-block-2">
                <img src="../../assets/index/img/advantages/circle-2.webp" alt="">
              </div>
            </div>
            <div class="row">
              <div class="testimonial-block-1">
                <div class="quote-icon">
                  <img src="../../../assets/index/img/advantages/puce.gif" alt="Analyse approfondie des performances commerciales par MasterField, offrant des insights précieux pour prendre des décisions stratégiques éclairées et guider l'avenir de votre entreprise" 
                    *ngIf="!mobile">
                  <img src="../../../assets/index/img/advantages/puce_triangle_mobile.gif" alt="Analyse approfondie des performances commerciales par MasterField, offrant des insights précieux pour prendre des décisions stratégiques éclairées et guider l'avenir de votre entreprise" 
                    *ngIf="mobile">
                </div>
                <p class="mb-48 advantage">Les analyses approfondies par MasterField vous
                  éclairent sur vos performances, vous guidant dans
                  des choix avertis pour l'avenir de votre entreprise.</p>
              </div>
              <div class="testimonial-block-1">
                <div class="quote-icon">
                  <img src="../../../assets/index/img/advantages/puce.gif" alt="Visites optimisées et interactions personnalisées avec les clients, contribuant à améliorer leur satisfaction et renforcer leur fidélité à votre marque" *ngIf="!mobile">
                  <img src="../../../assets/index/img/advantages/puce_triangle_mobile.gif" alt="Visites optimisées et interactions personnalisées avec les clients, contribuant à améliorer leur satisfaction et renforcer leur fidélité à votre marque" *ngIf="mobile">
                </div>
                <p class="mb-48 advantage">Des visites optimisées et des interactions
                  individualisées élèvent la satisfaction des clients,
                  cimentant leur fidélité à votre marque.</p>
              </div>
              <div class="testimonial-block-1">
                <div class="quote-icon">
                  <img src="../../../assets/index/img/advantages/puce.gif" alt="Intégration fluide de la solution, augmentant l'efficacité et la productivité des visites clients, permettant ainsi de concentrer l'énergie sur la croissance du chiffre d'affaires" 
                    *ngIf="!mobile">
                  <img src="../../../assets/index/img/advantages/puce_triangle_mobile.gif" alt="Intégration fluide de la solution, augmentant l'efficacité et la productivité des visites clients, permettant ainsi de concentrer l'énergie sur la croissance du chiffre d'affaires" 
                    *ngIf="mobile">
                </div>
                <p class="mb-48 advantage">L'intégration optimale accroît l'efficience et la
                  productivité des visites clients, recentrant votre
                  énergie sur l'élévation de votre chiffre d'affaires.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Our Advantages End -->
  <!-- about Us Start -->
  <section class="about-sec wow fadeInUp pb-0" data-wow-delay="400ms">
    <div class="container-fluid">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-4 first_img_roles_section">
          <div>
            <img class="br-24" src="../../../assets/index/img/section_roles/cover_phone_section_MF.webp" alt=""
              style="max-height: 520Px;">
          </div>
        </div>
        <div class="col-lg-8 col-md-8">
          <div class="mb-24">
            <h3 class="fw-400">Découvrez Comment Chaque Rôle Optimise son Efficacité 
              <span style="color: #016d6d;">MasterField</span></h3>
          </div>
          <p class="mb-24" style="font-size: larger;text-align: left;">
            MasterField révolutionne la gestion des équipes commerciales sur le terrain. 
            Que vous soyez commercial, directeur commercial ou assistant commercial. notre solution vous 
            permet de planifier vos visites commerciales de manière optimale et de suivre chaque déplacement 
            et interaction client avec précision. Découvrez ci-dessous comment chaque rôle peut utiliser 
            MasterField pour maximiser l'efficacité, améliorer les processus et augmenter les performances commerciales.</p>
          <div class="mb-48">
            <img class="br-24 phone_roles" src="../../../assets/index/img/section_roles/phone_mf.webp" alt=""
              style="max-height: 370Px;top: 75%;position: absolute;right: 0%;">
          </div>
          <a class="cus-btn cta_roles" href="../contact" [routerLink]="['../contact']" (click)="scrollToTop()">
            <div class="">
              <p class="button-text">Essayer gratuitement  pendant 15 jours </p>
            </div>
            <div class="cus-btn-icon">
              <img src="../../../assets/index/img/advantages/puce.gif"/>
            </div>
          </a>
        </div>
        <img class="br-24 bottom_cover_roles" src="../../../assets/index/img/section_roles/cover_colors.webp" alt="">
      </div>
    </div>
    <!-- DIRECTORS ROLE -->
    <!-- Managing commercial team -->
    <div class="container-fluid mt-3" style="padding-top: 10% !important;">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="label-box mb-24 role_title role_title_dc">
            <p class="role_title">Directeur / Responsable commerciale</p>
          </div>
          <div class="mb-24">
            <p class="fw-500 role_title">Facilitez la gestion de votre équipe commerciale</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Restez informé des actualités récentes et des données clients;</p>
            </li>
            <li>
              <p class="puce_roles">Ajoutez et affectez facilement de nouveaux clients à votre équipe;</p>
            </li>
            <li>
              <p class="puce_roles">Assurez-vous de suivre les visites de vos commerciaux sur la carte
                géographique;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_left" src="../../../assets/index/img/section_roles/09.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- Tracking & optimize productivity -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_right" src="../../../assets/index/img/section_roles/08.webp" alt="">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Suivez et optimisez la productivité de votre Équipe Commerciale</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Suivi les visite passés et à venir de votre équipe en un clin d'œil;</p>
            </li>
            <li>
              <p class="puce_roles">Ajustez les priorités de vos commerciaux pour maximiser leur efficacité;</p>
            </li>
            <li>
              <p class="puce_roles">Identifiez les actions effectuées et celles négligées pour relancer votre équipe;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
    <!-- Reforcing collaboration team -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Renforcez la collaboration au sein de l'équipe</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Renforcez la communication avec votre équipe pour une meilleure coordination;</p>
            </li>
            <li>
              <p class="puce_roles">Facilitez le partage des documents essentiels;</p>
            </li>
            <li>
              <p class="puce_roles">Tenez-vous informé des difficultés rencontrées par votre équipe;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_left" src="../../../assets/index/img/section_roles/12.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- Progressing productivity -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_right" src="../../../assets/index/img/section_roles/06.webp" alt="">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Mesurez la productivité et progressez</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Suivez régulièrement les performances de votre équipe;</p>
            </li>
            <li>
              <p class="puce_roles">Évaluez efficacement les résultats commerciaux de votre équipe;</p>
            </li>
            <li>
              <p class="puce_roles">Analysez les résultats et identifier les améliorations nécessaires pour
                augmenter les chiffres de vente de votre équipe;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>

    <!-- COMMERCIALS ROLE -->
    <!-- Visualize all customers -->
    <div class="container-fluid mt-3" >
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="label-box mb-24 role_title role_title_c">
            <p class="black role_title">Commercial</p>
          </div>
          <hr>
          <div class="mb-24">
            <p class="fw-500 role_title">Visualisez tous les clients</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Consultez d'un coup d'oeil rapide tout le portefeuille client;</p>
            </li>
            <li>
              <p class="puce_roles">Enregistrez des nouveaux client et assignez des visites à votre équipe commerciale;</p>
            </li>
            <li>
              <p class="puce_roles">Classifiez vos clients en fonction du nombre de visites à effectuer;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_left" src="../../../assets/index/img/section_roles/c_1.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- Manage easily all customers -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_right" src="../../../assets/index/img/section_roles/c_2.webp" alt="">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Gérez vos clients facilement</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Consultez tous vos clients en un coup d'œil;</p>
            </li>
            <li>
              <p class="puce_roles">Ajoutez des nouveaux clients en quelques clics;</p>
            </li>
            <li>
              <p class="puce_roles">Restez informé des dernières nouvelles et des informations clients;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
    <!-- Improve your team -->
    <div class="container-fluid mt-3" >
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Améliorez la collaboration avec votre équipe</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Maintenez une communication avec votre équipe d'équipe;</p>
            </li>
            <li>
              <p class="puce_roles">Partagez facilement des information ou des documents avec les membres de votre équipe;</p>
            </li>
            <li>
              <p class="puce_roles">Déposez vos demandes de congé et signalez vos absences facilement pour
                une gestion optimale des ressources humaines;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_left" src="../../../assets/index/img/section_roles/c_3.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- Simplify planning of visits customers -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_right" src="../../../assets/index/img/section_roles/c_4.webp" alt="">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Simplifiez la planification de vos visites clients</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Organisez efficacement votre journée et planifier les clients à visiter;</p>
            </li>
            <li>
              <p class="puce_roles">Préparez les actions et les objectifs pour chaque rencontre avec vos clients;</p>
            </li>
            <li>
              <p class="puce_roles">Gagnez du temps et optimisez vos déplacements;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
    
    <!-- ASSISTANT COMMERCIALS ROLE -->
    <!-- Tracking activities of team-->
    <div class="container-fluid mt-3" >
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-1"></div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="label-box mb-24 role_title role_title_ac">
            <p class="black role_title">Assistant(e) commercial(e)</p>
          </div>
          <hr>
          <div class="mb-24">
            <p class="fw-500 role_title">Suivez en détail l'activité des commerciaux</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Suivez les visite clients effectués ou manqués par les commerciaux;</p>
            </li>
            <li>
              <p class="puce_roles">Relancez les commerciaux pour les visites manquées;</p>
            </li>
            <li>
              <p class="puce_roles">Vérifiez et signalez les actions des commerciaux incomplètes;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_left" src="../../../assets/index/img/section_roles/ac_1.webp" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- Collaborate with direction -->
    <div class="container-fluid mt-3">
      <div class="row row-gap-4 align-items-center">
        <div class="col-lg-4 col-md-3">
          <div>
            <img class="br-24 icon_roles_section icon_right" src="../../../assets/index/img/section_roles/ac_2.webp" alt="">
          </div>
        </div>
        <div class="col-lg-7 col-md-8 text-left">
          <div class="mb-24">
            <p class="fw-500 role_title">Collaborez et alignez l'équipe commerciale avec la direction</p>
          </div>
          <ul>
            <li>
              <p class="puce_roles">Améliorez la fluidité de la communication entre les membre de l'équipe et la
                direction;</p>
            </li>
            <li>
              <p class="puce_roles">Communiquez les réalisations au directeur;</p>
            </li>
            <li>
              <p class="puce_roles">Signalez les problèmes rencontrés au support technique;</p>
            </li>
          </ul>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
  </section>
  <!-- about Us End -->
  <!-- Q&A Start -->
  <section class="testimonial-sec py-80 wow fadeInUp pt-0" data-wow-delay="800ms" >
    <div class="container-fluid" id="qAnda" style="padding: 5vw 5vw;">
      <div class="mb-24">
        <h3 class="fw-400">Q&A</h3>
        <p><b>Vous trouverez ci-dessous les questions les plus fréquemment posées par nos clients</b></p>
      </div>
      <div class="row row-gap-4 align-items-center">
        <div id="accordion">
          <div class="card card-QA first_qst">
            <div class="card-header border-r card-header-bg-right" id="headingOne" data-toggle="collapse" 
              data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              <h5 class="mb-3 pt-3">
                  <b>Q1: </b>Comment puis-je commencer à utiliser <b>MASTERFIELD</b> pour la gestion des équipes terrain et de force de vente ?
              </h5>
            </div>
            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">
                Vous pouvez demander un compte d'essai puis choisissez le plan qui vous convient , Nos équipes vont prendre en
                charge la mise en œuvre de la solution et vous accompagnent tout au long du processus.
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-l" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              <h5 class="mb-3 pt-3">
                  <b>Q2: </b>Comment votre Solution peut-elle m'aider à gérer plus efficacement mes <b>Visites client </b>?
              </h5>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
              <div class="card-body card-body-l">
                Les visites clients sur MasterField sont gérées via un outil avancée " La gestion intelligente des visites" qui représente une
                assistance automatique du déroulement de vos visites tout en se basant sur une classification des clients faite à l'avance
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-r card-header-bg-right" id="headingThree" data-toggle="collapse" 
              data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              <h5 class="mb-3 pt-3">
                  <b>Q3: </b>Quelles fonctionnalités offrez-vous pour la <b>planification</b> de mes actions commerciales ?
              </h5>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
              <div class="card-body">
                MasterField vous offre des fonctionnalités avancées notamment en création des calendriers,de définition des objectif
                d'orientation de votre force de vente par secteur, vous pouvez ainsi collaborer efficacement avec vos équipes et suivre
                chaque action en garantissant une exécution harmonieuse
              </div>
            </div>
          </div>

          <div class="card card-QA">
            <div class="card-header border-l" id="headingFor" data-toggle="collapse" 
              data-target="#collapseFor" aria-expanded="true" aria-controls="collapseFor">
              <h5 class="mb-3 pt-3">
                  <b>Q4: </b>Comment puis-je mesurer le succès de mes actions commerciales à l'aide de <b>Masterfield</b>?
              </h5>
            </div>
            <div id="collapseFor" class="collapse" aria-labelledby="headingFor" data-parent="#accordion">
              <div class="card-body card-body-l">
                Vous pouvez suivre les métriques clés en visualisant les données et statistiques sous forme des tableaux de bords ,vous
                pouvez ainsi obtenir des rapports par visites ce qui vous permet d'identifier les tendances et prendre des décisions
                informées.
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-r card-header-bg-right" id="headingFive" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseTwo">
              <h5 class="mb-3 pt-3">
                  <b>Q5: </b>Est-ce que votre plateforme prend en charge l'intégration avec d'autres outils que nous utilisons
                  déjà pour nos opérations commerciales ?
              </h5>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
              <div class="card-body">
                Absolument! MasterField est conçu pour s'intégrer facilement à vos systèmes en toute fluidité afin que vous puissiez
                centraliser vos données , cela à condition que vos sytèmes soient aussi facile à s'intégrer avec toute autre solution.
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-l" id="headingSix" data-toggle="collapse" 
              data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
              <h5 class="mb-3 pt-3">
                  <b>Q6: </b>Quel type de <b>support</b> offrez-vous si j'ai des questions ou des problèmes lors de 
                  l'utilisation de la plateforme ?
              </h5>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
              <div class="card-body card-body-l">
                Nous offrons un support dédié pour répondre à vos questions et demandes et résoudre vos problèmes dans les plus
                brefs délais
              </div>
            </div>
          </div>

          <div class="card card-QA">
            <div class="card-header border-r card-header-bg-right" id="headingSeven" data-toggle="collapse" 
              data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
              <h5 class="mb-3 pt-3">
                  <b>Q7: </b>Comment garantissez-vous la <b>sécurité</b> des données sensibles liées à nos actions commerciales ?
              </h5>
            </div>
            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
              <div class="card-body">
                Vos données sensibles sont cryptées et gérées dans des serveurs sécurisée avec la possibilité de développer votre
                propore base de données en fonction de votre besoin
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-l" id="headingEight" data-toggle="collapse" data-target="#collapseEight" 
              aria-expanded="false" aria-controls="collapseEight">
              <h5 class="mb-3 pt-3">
                  <b>Q8: </b>Quelle fonctionnalité offrez-vous pour l'<b>échange</b> inter-membres ?
              </h5>
            </div>
            <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
              <div class="card-body card-body-l">
                Vous pouvez générér des rapports détaillés et avoir la traçabilité des visites clients, 
                actions des visites ainsi que les pièces jointes
              </div>
            </div>
          </div>
          <div class="card card-QA">
            <div class="card-header border-r card-header-bg-right" id="headingNine" data-toggle="collapse" 
              data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
              <h5 class="mb-3 pt-3">
                  <b>Q9: </b>Comment puis-je gérer mes clients sur plusieurs <b>sites géographiques</b> ?
              </h5>
            </div>
            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordion">
              <div class="card-body">
                Notre solution novatrice vous offre un avantage de gestion de vos clients sur différentes zones géographiques via la
                fonctionnalité de la gestion multivilles / sites / Services et départements .
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Q&A End -->